import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './app/store';
import { setupAxiosInterceptors } from './app/interceptors';
import App from './App';
import Routes from './app/routes'
//import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import moment from 'moment';
import 'moment/locale/pt-br';

setupAxiosInterceptors(store);

// "ResizeObserver loop completed with undelivered notifications" é um aviso
// benigno do browser (não um erro real) — acontece quando um ResizeObserver
// (ex.: ResponsiveContainer do Recharts) reage a resizes mais rápido do que
// o browser consegue entregar as notificações, comum dentro de containers
// que animam altura (Accordion do PrimeReact). Adiar o callback via
// requestAnimationFrame reduz a chance do loop síncrono acontecer, mas não
// elimina 100% (o browser ainda pode disparar o aviso em alguns casos).
// window.addEventListener('error', ...) AQUI não bastaria pra impedir o
// overlay de erro do CRA de capturar o que sobrar — o listener do próprio
// overlay (react-error-overlay, dentro do bundle) já registra antes do
// nosso rodar. A supressão desse restante está em public/index.html (um
// <script> inline, que roda antes do bundle carregar).
if (window.ResizeObserver) {
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class extends OriginalResizeObserver {
        constructor(callback) {
            super((entries, observer) => {
                window.requestAnimationFrame(() => callback(entries, observer));
            });
        }
    };
}

const rootElement = document.getElementById('root')
ReactDOM.render(
        <HashRouter>
            <ScrollToTop>
                <Provider store={store}>
                    <Routes/>
                </Provider>
            </ScrollToTop>
        </HashRouter>
    ,
    rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();